<footer class="app-footer">
  <span>Kluś &copy; 2021</span>
</footer>